import * as React from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Rating,
  TextareaAutosize,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Alert
} from '@mui/material';

import { useCompany } from '../../contexts/Company';
import { supabase } from '../../supabaseClient';
import { useAuth } from '../../contexts/auth'
import { completeActivity } from '../../hooks/activity';
  
import { generateDailyCode } from '../../utils';


export default function Attendance({ session, activity, openAttendance, setOpenAttendance, setAttendance, setCongratulations }) {
  const [code, setCode] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [feedback, setFeedback] = React.useState('');
  const [gender, setGender] = React.useState('');
  const [rating, setRating] = React.useState(0);
  const [isFormCompleted, setIsFormCompleted] = React.useState(false);
  const [alertVisibility, setAlertVisibility] = React.useState(false);
  const [alertText, setAlertText] = React.useState('');
  
  const {user} = useAuth()
  const company = useCompany();

  const handleClickOpen = () => {
    setOpenAttendance(true);
  };

  const handleClose = () => {
    setOpenAttendance(false);
  };

  const handleAccept = () => {
    const validCode = company?.demo ? 'CODIGO' : generateDailyCode()
    if (code === validCode || company?.id == '37') { // TODO: hacer que sea con activities.metadata.requestData == true
      if (!feedback) {
        setAlertVisibility(true);
        setAlertText('Debes escribir tus comentarios.');
        return;
      }
      if (!rating) {
        setAlertVisibility(true);
        setAlertText('Marca tu puntuación.');
        return;
      }
      
      setAlertVisibility(false)
      setAttendance(true);
      sendFeedback()
      
      localStorage.setItem(company.id +''+ session.id + 'at', 'true'); // DEMO

      completeActivity(user, activity);
      setCongratulations(true)
    }
    
    setOpenAttendance(false);

  };


  const handleCodeChange = (e) => {
    setCode(e.target.value);
  };

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleFeedbackChange = (e) => {
    setFeedback(e.target.value);
  };

  const handleGenderChange = (e) => {
    setGender(e.target.value);
  };

  const handleRatingChange = (newValue) => {
    setRating(newValue);
  };

  const sendFeedback = async () => {
    // Insert feedback and rating into the "feedback" table
    const { data, error } = await supabase
    .from('feedback')
    .insert([
      {
        session_id: session.id,
        feedback,
        rating,
        user_first_name: firstName,
        user_last_name: lastName,
        user_gender: gender,
      },
    ]);
  
    if (error) {
      console.error('Error saving feedback:', error);
    } else {
      console.log('Feedback saved successfully:', data);
    }
  };

  React.useEffect(() => {
    const validCode = company?.demo ? 'CODIGO' : generateDailyCode()

    if (company?.id == '37') { // TODO: hacer que sea con activities.metadata.requestData == true
      if (firstName !== '' && lastName !== '' && gender !== '') {
        setIsFormCompleted(true);
      } else {
        setIsFormCompleted(false);
      }
    }else {
      if (code === validCode){
        setIsFormCompleted(true);
      }else{
        setIsFormCompleted(false)
      }
    }
  }, [firstName, lastName, gender, code]);

  return (
    <div>
      <Dialog open={openAttendance} onClose={handleClose}>
        <DialogTitle>{company?.id === 45 ? "Mark Attendance" : "Marcar asistencia"}</DialogTitle>
        <DialogContent>
          {alertVisibility && 
            <Alert severity="error">{alertText}</Alert>
          }
          {company?.id == 45 ? (
            <DialogContentText>
              Use the code provided by the facilitator to mark attendance.
            </DialogContentText>
          ) : (
            <DialogContentText>
              Usa el código otorgado por el facilitador para marcar asistencia.
            </DialogContentText>
          )}
          {company?.id != '37' &&
          <TextField
            autoFocus
            margin="dense"
            id="code"
            label={company?.id === 45 ? "Code" : "Código"}
            fullWidth
            variant="standard"
            value={code}
            onChange={handleCodeChange}
          />}
          {company?.id == '37' && <>
          <TextField
            margin="dense"
            id="firstName"
            label="Nombre"
            fullWidth
            variant="standard"
            value={firstName}
            onChange={handleFirstNameChange}
          />
          <TextField
            margin="dense"
            id="lastName"
            label="Apellido"
            fullWidth
            variant="standard"
            value={lastName}
            onChange={handleLastNameChange}
          />
          <FormControl fullWidth>
            <InputLabel id="gender-label">Género</InputLabel>
            <Select
              labelId="gender-label"
              id="gender-select"
              value={gender}
              onChange={handleGenderChange}
            >
              <MenuItem value="masculino">Masculino</MenuItem>
              <MenuItem value="femenino">Femenino</MenuItem>
              <MenuItem value="otro">Otro</MenuItem>
            </Select>
          </FormControl>
         </>}

          {isFormCompleted && (
            <div>
              <DialogContentText>
                Proporciona tu opinión sobre la sesión
              </DialogContentText>
              <Rating
                name="feedback-rating"
                size="large"
                value={rating}
                onChange={(event, newValue) => {
                  handleRatingChange(newValue);
                }}
              />
              <TextareaAutosize
                minRows={5}
                rows={5}
                placeholder="Escribe aquí tu feedback"
                value={feedback}
                onChange={handleFeedbackChange}
                style={{ width: '100%', marginTop: '8px' }}
              />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{company?.id === 45 ? 'Cancel' : 'Cancelar'}</Button>
          <Button onClick={handleAccept}>{company?.id === 45 ? 'Accept' : 'Aceptar'}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
